import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

export const routing = defineRouting({
  // 支持的语言列表
  locales: ["en", "zh"],

  // 默认语言
  defaultLocale: "zh",

  // URL 前缀策略：'always' 表示总是显示语言前缀，'as-needed' 表示默认语言不显示前缀
  localePrefix: "as-needed",
});

// 导出示航工具（类型安全）
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);

